import Vue from 'vue'
import VueRouter from 'vue-router'
import needActiveCallBack from './active'
import i18n from '@/lang'
Vue.use(VueRouter)

// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push (location, onResolve, onReject) {
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//   return originalPush.call(this, location).catch(err => err)
// }

const routes = [
  // 首页重定向
  {
    path: '/',
    redirect: { name: 'Home' },
    meta: { navHide: true }
  },

  // 登录注册页
  {
    path: '/register',
    alias: '/login',
    name: 'Register',
    component: () => import('@/views/Register'),
    meta: { navHide: true, noLogin: true }
  },
  // 注册页 输入验证码
  {
    path: '/register-verification',
    name: 'RegisterVerification',
    component: () => import('@/views/RegisterVerification'),
    meta: { navHide: true, noLogin: true }
  },
  // VIDA的用户协议
  {
    path: '/vida',
    name: 'Vida',
    component: () => import('@/views/Vida'),
    meta: { title: 'Vida', noLogin: true }
  },
  // 用户协议
  {
    path: '/termsAndConditions',
    name: 'TermsAndConditions',
    component: () => import('@/components/Translate/TermsAndConditions'),
    meta: { title: 'flashPayTerms', noLogin: true }
  },
  // 隐私协议
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: () => import('@/components/Translate/PrivacyPolicy'),
    meta: { title: 'privacy_policy', noLogin: true }
  },
  // 首页
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home'),
    meta: { title: 'title', leftHide: true, class: true }
  },
  // card 首页
  {
    path: '/card',
    name: 'Card',
    component: () => import('@/views/Card'),
    meta: { title: 'back_card', leftHide: true }
  },
  {
    path: '/message',
    name: 'Message',
    component: () => import('@/views/Message')
  },
  // 个人中心
  {
    path: '/me',
    name: 'Me',
    component: () => import('@/views/Me'),
    meta: { title: 'me_tit', class: true, leftHide: true }
  },
  // 交易记录
  {
    path: '/transaction-record',
    name: 'TransactionRecord',
    component: () => import('@/views/TransactionHistory'),
    meta: { title: 'transactions', needActive: true }
  },
  // 印尼银行信息
  {
    path: '/payment-info',
    name: 'PaymentInfo',
    component: () => import('@/views/PaymentInfo'),
    meta: { title: 'cashier', auth: true }
  },
  // 手机充值
  {
    path: '/mobile-top-up',
    name: 'MobileTopUp',
    component: () => import('@/views/MobileTopUp'),
    meta: { title: 'mobileTopUp', needActive: true }
  },
  // 手机充值支付
  {
    path: '/mobile-top-up-pay',
    name: 'MobileTopUpPay',
    component: () => import('@/views/MobileTopUpPay'),
    meta: { title: 'mobileTopUp', needActive: true }
  },
  // 手机充值结果
  {
    path: '/mobile-top-up-result',
    name: 'MobileTopUpResult',
    component: () => import('@/views/MobileTopUpResult'),
    meta: { title: 'mobileTopUp', needActive: true }
  },
  // 卡管理
  // 选择卡类型
  {
    path: '/card/select-type',
    name: 'CardSelectType',
    component: () => import('@/views/CardSelectType'),
    meta: { title: 'selectType' }
  },
  // 银行账户选择页面
  {
    path: '/card/add-bank-account',
    name: 'CardAddBankAccount',
    component: () => import('@/views/CardAddBankAccount'),
    meta: { title: 'add_new_card' }
  },
  // 添加账户 结果页面
  {
    path: '/card/result',
    name: 'CardAddResult',
    component: () => import('@/views/CardAddResult'),
    meta: { title: 'add_new_card' }
  },
  // 实名认证(低级别)
  {
    path: '/activate-low-level/step-1',
    name: 'ActivateLowLevelStep1',
    component: () => import('@/views/ActivateLowLevelStep1'),
    meta: { title: 'activate_wallet' }
  },
  {
    path: '/activate-low-level/step-2',
    name: 'ActivateLowLevelStep2',
    component: () => import('@/views/ActivateLowLevelStep2'),
    meta: { title: 'activate_wallet' }
  },
  {
    path: '/activate-low-level/step-3',
    name: 'ActivateLowLevelStep3',
    component: () => import('@/views/ActivateLowLevelStep3'),
    meta: { title: 'activate_wallet' }
  },
  {
    path: '/activate-low-level/step-4',
    name: 'ActivateLowLevelStep4',
    component: () => import('@/views/ActivateLowLevelStep4'),
    meta: { title: 'activate_wallet' }
  },
  {
    path: '/activate-low-level/result',
    name: 'ActivateResult',
    component: () => import('@/views/ActivateResult'),
    meta: { title: 'activate_wallet' }
  },
  // 实名认证(高级别)
  // {
  //   path: '/activate-high-level',
  //   name: 'ActivateHighLevel',
  //   component: () => import('@/views/ActivateHighLevel'),
  //   meta: { title: 'dip_chip' }
  // },
  // {
  //   path: '/activate-high-level/step-1',
  //   name: 'ActivateHighLevelStep1',
  //   component: () => import('@/views/ActivateHighLevelStep1'),
  //   meta: { title: 'dip_chip' }
  // },
  // {
  //   path: '/activate-high-level/step-2',
  //   name: 'ActivateHighLevelStep2',
  //   component: () => import('@/views/ActivateHighLevelStep2'),
  //   meta: { title: 'dip_chip' }
  // },
  // 我的用户信息
  {
    path: '/me-info',
    name: 'MeInfo',
    component: () => import('@/views/MeInfo'),
    meta: { title: 'personaInformation', needActive: true }
  },
  // 联系我们
  {
    path: '/me-contact-us',
    name: 'MeContactUs',
    component: () => import('@/views/MeContactUs'),
    meta: { title: 'contact_us' }
  },
  // 支付设置
  {
    path: '/me-pay-set',
    name: 'MePaySet',
    component: () => import('@/views/MePaySet'),
    meta: { title: 'paymentSettings', needActive: true }
  },
  // 校验生日
  {
    path: '/check-birthday',
    name: 'CheckBirthday',
    component: () => import('@/views/CheckBirthday'),
    meta: { title: 'paymentSettings', needActive: true }
  },
  // 支付设置
  {
    path: '/me-about-flash-pay',
    name: 'MeAboutFlashPay',
    component: () => import('@/views/MeAboutFlashPay'),
    meta: { title: 'about_flashpay' }
  },

  // FAQ
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import('@/views/FAQ'),
    meta: { title: 'FAQ' }
  },

  // 更改支付密码
  {
    path: '/me-change-password',
    name: 'MeChangePayPassword',
    component: () => import('@/views/MeChangePayPassword'),
    meta: { title: 'change_payment_password' }
  },
  // 忘记密码
  {
    path: '/otp',
    name: 'OTP',
    component: () => import('@/views/OTP'),
    meta: { title: 'change_payment_password' }
  },
  { // 充值选择卡账户类型
    path: '/topUp',
    name: 'TopUp',
    component: () => import('@/views/TopUp'),
    meta: { title: 'topUpAdminTitle', needActive: true, cardFlag: false }
  },
  { // 充值页面
    path: '/topUpAdmin',
    name: 'TopUpAdmin',
    component: () => import('@/views/TopUp/components/TopUpAdmin'),
    meta: { title: 'topUpAdminTitle', needActive: true, cardFlag: false }
  },
  { // uniBank
    path: '/uni-bank',
    name: 'UniBank',
    component: () => import('@/views/TopUp/UniBank'),
    meta: { title: 'topUpAdminTitle', needActive: true, cardFlag: false }
  },
  // 提现页面
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: () => import('@/views/Withdraw'),
    meta: { title: 'withdraw_btn', needActive: true, cardFlag: false }
  },
  // 提现结果
  {
    path: '/withdraw-result',
    name: 'WithdrawResult',
    component: () => import('@/views/WithdrawResult'),
    meta: { title: 'withdraw_btn', needActive: true, cardFlag: false }
  },
  // 转账页面
  { // 转账页面-首页
    path: '/transfer',
    name: 'Transfer',
    component: () => import('@/views/Transfer'),
    meta: { title: 'Transfer', needActive: true }
  },
  { // 转账页面-手机号转账中
    path: '/transferToAccount',
    name: 'TransferToAccount',
    component: () => import('@/views/TransferToAccount'),
    meta: { title: 'transfer_to_flashpay_account', needActive: true }
  },
  {
    // 转账页面-转账到银行
    path: '/transferToBank',
    name: 'TransferToBank',
    component: () => import('@/views/TransferToBank'),
    meta: { title: 'transfer', needActive: true }
  },
  {
    // 转账页面-转账到银行 - 校验
    path: '/transferToBankVerify',
    name: 'TransferToBankVerify',
    component: () => import('@/views/TransferToBank/Verify.vue'),
    meta: { title: 'transfer', needActive: true }
  },
  {
    // 转账页面-转账到银行 - 确认信息
    path: '/transferToBankConfirm',
    name: 'TransferToBankConfirmInformation',
    component: () => import('@/views/TransferToBank/ConfirmInfomation.vue'),
    meta: { title: 'transfer', needActive: true }
  },
  {
    // 转账页面- 转账到个人账户
    path: '/TransferToAccount',
    name: 'TransferToAccount',
    component: () => import('@/views/TransferToAccount'),
    meta: { title: 'transferToBank', needActive: true }
  },
  {
    // 转账页面- 转账到个人账户 - 输入用户账号
    path: '/TransferToAccountInputUser',
    name: 'TransferToAccountInputUser',
    component: () => import('@/views/TransferToAccountInputUser'),
    meta: { title: 'to_flashpay_wallet_account', needActive: true }
  },
  {
    path: '/haveStepsDetail',
    name: 'HaveStepsDetail',
    component: () => import('@/components/HaveStepsDetail'),
    meta: { title: 'transaction_details', navHide: true, needActive: true }
  },
  {
    path: '/haveNoStepsDetail',
    name: 'HaveNoStepsDetail',
    component: () => import('@/components/HaveNoStepsDetail'),
    meta: { title: 'transaction_details', navHide: true, needActive: true }
  },
  {
    path: '/union-bank-confirm',
    name: 'UnionBankConfirm',
    component: () => import('@/views/UnionBankConfirm'),
    meta: { title: 'transaction_details', navHide: true }
  },
  // 404页面
  {
    path: '/404',
    name: '404Page',
    component: () => import('@/views/ErrorPage/404.vue'),
    meta: { navHide: true, title: '404', noLogin: true }
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// 跳转前的判断激活态
needActiveCallBack(router)

router.beforeEach((to, from, next) => {
  document.title = i18n.t(to.meta.title) || 'FlashPay Wallet'
  next()
})

export default router
